import React, { useState, useEffect, useContext, createContext, } from 'react';
const SessionContext = createContext(window.config.session_user);
export const SessionProvider = ({ children }) => {
    const [sessionUser, setSessionUser] = useState(window.config.session_user);
    useEffect(() => {
        const handleSessionUserChange = () => {
            setSessionUser(window.config.session_user);
        };
        window.addEventListener('session_user_updated', handleSessionUserChange);
        return () => {
            window.removeEventListener('session_user_updated', handleSessionUserChange);
        };
    }, []);
    return (React.createElement(SessionContext.Provider, { value: sessionUser }, children));
};
export const useSession = () => useContext(SessionContext);
